import { Box, Button, Card, CardContent, Grid } from '@mui/material'
import React from 'react'
import { ArrowLeftCircle, Plus, Printer } from 'react-feather'
import { AllowedAccess } from 'react-permission-role'
import { ModalModule } from '../Modal'
import { VehicleExpensesTable } from './VehicleExpensesTable'

export const VehicleExpenses = ({useFetchInit}) => {
  
  const {
    Actions,
  } = useFetchInit

  const {handleClickShowModal, handleClickCloseForm, generatePDF} = Actions
  
  return (
    <AllowedAccess permissions={['49_ADMIN', '146_CATALOGO_VEHICULOS']} renderAuthFailed={<p>Error</p>}>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12}>
        
          <Card style={{ zIndex: '1' }}>
            <CardContent>
              <div className="h4 mt-1 mb-1">Gastos Vehiculos</div>
              <div className="border-bottom border-dark"></div>
            
              <Button
                startIcon={<Plus/>}
                size='medium'
                type='button'
                variant='contained' 
                color='primary' 
                sx={{marginTop: 4}}
                onClick={()=>handleClickShowModal('', 'Formulario de gastos', 'expenses-section', {}, 'EDITABLE')}

              >
                  Agregar Gasto
              </Button>

              <div className="pt-4"></div>
              <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
                <VehicleExpensesTable useFetchInit = {useFetchInit}/>
              </Grid>
              <ModalModule useFetchInit={useFetchInit} />
              
              <Box className="text-center" sx={{mt: 7, mb: 7, }}>
                <Button 
                    startIcon={<ArrowLeftCircle/>}
                    variant="contained"
                    type="button" 
                    className='btn-round'
                    color='warning'
                    onClick={handleClickCloseForm} 
                    sx={{ marginRight: 5, marginLeft: 1 }}
                >
                    Volver
                </Button>
                <Button 
                    startIcon={<Printer/>}
                    variant="contained"
                    type="button" 
                    className='btn-round'
                    color='info'
                    onClick={generatePDF} 
                    sx={{ marginRight: 5, marginLeft: 1 }}
                >
                    Imprimir Lista
                </Button>
              </Box>
            </CardContent>
          </Card>
          
        </Grid>
      </Grid>
    </AllowedAccess>
  )
}
